import React, { useEffect, useState } from "react";
import { Fade } from "react-awesome-reveal";
import AnimatedLettersFast from "../RuberBand/RubberBand";
import { email } from "../../config/Social";
import "./Introduction.css";

const Introduction = () => {
  const [letterClass, setLetterClass] = useState("text-animate-fast");
  const introName = "Jay Patel.".split("");
  const introTitle = "I build AI systems.".split("");

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-fast-hover");
    }, 30);
  });

  return (
    <section className="intro-center-main">
      <div className="center-container">
        <Fade direction="up" duration={300}  cascade>
          <h3 className="intro-intro">Hello, I’m</h3>
          <h1 className="intro-name">
            <AnimatedLettersFast
              letterClass={letterClass}
              strArray={introName}
              idx={15}
            />
          </h1>
          <h1 className="intro-main">
            <AnimatedLettersFast
              letterClass={letterClass}
              strArray={introTitle}
              idx={15}
            />
          </h1>
          <h3 className="intro-sub">
            I'm an AI engineer working on end-to-end AI architectures, from orchestration and prompting to memory, knowledge, and reliability. Currently, I'm designing AI features for healthcare simulation products at <a href="https://www.iris-sim.com" target="_blank" rel="noopener noreferrer">iRIS</a>.
          </h3>
          <h3 className="intro-button">
            <a
              href={`mailto:${email}`}
            >
              Contact Me!
            </a>
          </h3>
        </Fade>
      </div>
    </section>
  );
};

export default Introduction;
